import { PaginaNode } from '@gql/graphql'
import { MagazineListing, GenericHero, Page, Prefooter } from 'components/organisms'
import styles from './MagazineHubTemplate.module.sass'

interface Props {
  pagina?: PaginaNode
  categorie?: any[] // Categorie Magazine?
  news?: any[] // MagazineNode[]
}

const MagazineHubTemplate = (props: Props) => {
  const { pagina = undefined, categorie = [], news = [] } = props

  return (
    <Page pagina={pagina} className={`${styles.root}`}>
      <main>
        <GenericHero pagina={pagina} />
        <MagazineListing categorie={categorie} news={news} />
        <Prefooter />
      </main>
    </Page>
  )
}

export default MagazineHubTemplate
